import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=4564a218&scoped=true"
import script from "./grade.vue?vue&type=script&lang=js"
export * from "./grade.vue?vue&type=script&lang=js"
import style0 from "./grade.vue?vue&type=style&index=0&id=4564a218&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564a218",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4564a218')) {
      api.createRecord('4564a218', component.options)
    } else {
      api.reload('4564a218', component.options)
    }
    module.hot.accept("./grade.vue?vue&type=template&id=4564a218&scoped=true", function () {
      api.rerender('4564a218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/grade.vue"
export default component.exports